/* eslint-disable */

import { registerMicroApps, runAfterFirstMounted, start, addGlobalUncaughtErrorHandler } from '../../../cdn/libs/qiankun/es/index.js'
import MC from '@/module/MC'
import fetch from 'isomorphic-fetch'
import { mapState, mapMutations } from 'vuex'
import consoleProxy from '@/module/utils/console'
import { appInfos, genActiveRule } from './appInfos'
import shareData from './shareData'

export default {
  name: 'app-master',
  watch: {
    $route (to, from) {
      this.setGlobalAnimation(' fade-transform-leave-to')

      if (to.path.split('/')[1] !== from.path.split('/')[1]) { // 不是在同一个子应用中切换
        let key
        for (let a in this.retryTimer) {
          if (from.path.indexOf(a) !== -1) {
            key = a
            break
          }
        }
        if (key) {
          window.clearTimeout(this.retryTimer[key].timer)
          this.retryTimer[key].timer = null
        }
      }
      // 切换页面时  将 errorApp page取消
      if (this.errorApp) this.errorApp = false

      // 匹配上 且第一次注册 再 注册子应用
      let flag = this.apps.some(item => to.path.indexOf(item.href) !== -1)
      if (flag && this.isFirstMount) {
        this.registerSubapp(to.path)
      }

      setTimeout(() => {
        this.setGlobalAnimation('fade-transform-leave-active')
      }, 100)
    }
  },
  data () {
    const ShareData = new shareData(this)
    const props = {
      data: {
        MC: MC
      },
      fns: {
        addRouter() {}
      },
      state: ShareData.microAppStateActions,
    }
    return {
      isApp:false,
      load404App: {},
      retryTimer: {},
      isFirstMount: true,
      tryRequestNum: 0,
      errorApp: false,
      appContent: null,
      apps: appInfos.map(app => {
        return {
          ...app,
          props,
          render: this.render,
          activeRule: genActiveRule(app.href)
        }
      })
    }
  },
  computed: {
    ...mapState('common', ['subApp'])
  },
  // 解决刷新 路由信息变化未触发的情况
  created () {
    let flag = this.apps.some(item => this.$route.path.indexOf(item.href) !== -1)
    if (flag && this.isFirstMount) this.registerSubapp(this.$route.path)
  },
  methods: {
    ...mapMutations('common', ['setAppLoading', 'setGlobalAnimation','setTagViewList']),
    registerSubapp (redirect) {
      if (!window.__POWERED_BY_QIANKUN__) {
        this.isFirstMount = false
        addGlobalUncaughtErrorHandler(this.globalError)
        this.initQiankun(redirect)
      } else {
        location.reload()
      }
    },
    globalError () {
      // 重置重连次数
      const curPath = this.$route.path.split('/')[1]
      if (this.retryTimer[curPath] && !this.retryTimer[curPath].timer) { // 有子应用的错误机制
        this.tryRequestNum = 0
        this.request(this.retryTimer[curPath].url)
      }
      // 404 页面 再次提示
      if (this.load404App[curPath]) {
        this.request(this.load404App[curPath])
      }
    },
    // 自定义的 fetch钩子函数 用于子应用 试错机制
    request (url) {
      const that = this
      return new Promise((resolve, reject) => {
        fetch(url, {
          herders: {
            'Access-Control-Request-Method': '*'
          },
          referrerPolicy: 'origin-when-cross-origin'
        })
        .then(res => {
          const key = that.$route.path.split('/')[1]
          // 子应用未部署情况
          if (res.status === 404) {
            // 提示
            that.$message.error('填写正确的项目地址或者请部署子应用')
            // 将其url添加404url中 用于下次再点击提示
            that.load404App[key] = url
            resolve() // 返回 状态给qiankun
          }
          // 重连机制 如果成功 需清除 重连列表
          that.tryRequestNum = 0
          if (that.retryTimer[key]) {
            window.clearTimeout(that.retryTimer[key].timer)
            delete that.retryTimer[key]
          }
          resolve(res) // 返回子应用资源给 主应用 否则会一直 pending中...
        })
        .catch(err => { // 捕获 子应用加载错误
          // 重新加载
          // 设定超时时间  5s  5s 内如果加载不出来 则进行再次加载
          const key = that.$route.path.split('/')[1]
          if (that.tryRequestNum <= 3) { // 重连三次
            let timer = setTimeout(() => {
              that.tryRequestNum++
              console.log(`正在重连子应用第${that.tryRequestNum}次`)
              that.request(url)
            }, 3000)
            that.retryTimer[key] = { timer, url }
          } else {
            that.errorApp = true
            that.tryRequestNum = 0
          }
          // 返回加载失败 去除pending状态
          reject(err)
        })
      })
    },
    render ({ appContent, loading }) {
      this.appContent = appContent
      this.setAppLoading(loading)
    },
    initQiankun () {
      const { apps } = this
      registerMicroApps(
        apps,
        { beforeLoad: [app => {}],
          beforeMount: [app => {}],
          afterUnmount: [app => {}],
          afterMount: [app => {}],
          beforeUnmount: [app => {}]
        },
        {
          fetch: this.request
        }
      )

      // 第一个子应用加载完毕
      runAfterFirstMounted(() => {
        // console.info('first app mounted')
      })
      // 启动微服务
      const jsSandbox = true
      start({
        excludeAssetFilter: url => url.indexOf('map.qq.com') !== -1,
        prefetch: false, // 是否开启预加载
        jsSandbox // 是否开启沙箱
      })
      if (jsSandbox) {
        window.console = consoleProxy(window.console)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/module/singleSpa/index.js